import React, { useEffect, useState } from "react";
import axios from "axios";
import FormularioNuevo from "./FormularioNuevo";
import HistorialGlobal from "./HistorialGlobal";
import CalendarioCitas from "./CalendarioCitas";
import NavBarSuperior from "./NavBarSuperior";
import Footer from "./Footer";

export default function FormularioStandard() {
  const [activeTab, setActiveTab] = useState("nuevo");
  const [registros, setRegistros] = useState([]);

  const fetchRegistros = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/formulario`, {
        headers: { Authorization: token },
      });
      setRegistros(res.data);
    } catch (err) {
      console.error("Error obteniendo registros:", err);
    }
  };

  useEffect(() => {
    fetchRegistros();
  }, []);

  return (
    <>
      {/* ===== HEADER SUPERIOR ===== */}
      <NavBarSuperior />

      {/* ===== CONTENEDOR GENERAL (MENÚ + CONTENIDO) ===== */}
      <div style={{ display: "flex", flex: 1 }}>
        {/* ===== MENÚ LATERAL ===== */}
        <ul
          className="nav flex-column nav-pills p-3"
          style={{
            backgroundColor: "rgb(37,74,128)",
            minHeight: "100vh",
            width: "220px",
            position: "fixed",
            top: "43px", // altura exacta del NavBarSuperior
            left: 0,
            borderTopRightRadius: "10px",
          }}
        >
          <li className="nav-item mb-2">
            <button
              className={`nav-link text-white w-100 text-start${
                activeTab === "nuevo" ? " active bg-light text-dark fw-bold" : ""
              }`}
              onClick={() => setActiveTab("nuevo")}
            >
              📋 Nuevo Registro
            </button>
          </li>

          <li className="nav-item mb-2">
            <button
              className={`nav-link text-white w-100 text-start${
                activeTab === "historial"
                  ? " active bg-light text-dark fw-bold"
                  : ""
              }`}
              onClick={() => setActiveTab("historial")}
            >
              📑 Historial Global
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link text-white w-100 text-start${
                activeTab === "citas" ? " active bg-light text-dark fw-bold" : ""
              }`}
              onClick={() => setActiveTab("citas")}
            >
              📅 Citas (WhatsApp)
            </button>
          </li>
        </ul>

        {/* ===== CONTENIDO PRINCIPAL ===== */}
        <main
          style={{
            marginLeft: "240px",
            paddingTop: "80px", // espacio entre header y contenido
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "40px",
            width: "100%",
            backgroundColor: "transparent",
            flex: 1,
          }}
        >
          {/* === FORMULARIO NUEVO === */}
          {activeTab === "nuevo" && (
            <FormularioNuevo
              usuario={localStorage.getItem("username")}
              onSubmit={async (formulario) => {
                const token = localStorage.getItem("token");
                try {
                  console.log("🟢 Enviando formulario desde Standard:", formulario);
                  await axios.post(
                    `${process.env.REACT_APP_API_URL}/formulario`,
                    formulario,
                    { headers: { Authorization: token } }
                  );
                  alert("Formulario enviado");
                  setActiveTab("historial");
                  fetchRegistros();
                } catch (err) {
                  console.error("❌ Error al guardar:", err);
                  alert("Error al guardar");
                }
              }}
            />
          )}

          {/* === HISTORIAL GLOBAL === */}
          {activeTab === "historial" && <HistorialGlobal registros={registros} />}

          {/* === CALENDARIO CITAS === */}
          {activeTab === "citas" && (
            <div className="card shadow p-4">
              <CalendarioCitas />
            </div>
          )}
        </main>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </>
  );
}

